module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user/school/shared/school-form/school-form.component.scss
// module id = ./src/app/user/school/shared/school-form/school-form.component.scss
// module chunks = main